import React, { useState } from "react";
import { NavLink, Outlet, Navigate, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, LineChart, Wallet, Users, Bug, Settings, Globe, LogOut, Menu, X, BellRing } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Visão Geral", icon: LayoutDashboard, end: true },
  { to: "/admin/analytics", label: "Analytics", icon: LineChart },
  { to: "/admin/sales", label: "Vendas & Pagamentos", icon: Wallet },
  { to: "/admin/users", label: "Usuários", icon: Users },
  { to: "/admin/alerts", label: "Alertas", icon: BellRing },
  { to: "/admin/feedback", label: "Relatos & Feedback", icon: Bug },
  { to: "/admin/settings", label: "Configurações", icon: Settings },
];
const linkCls = ({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm transition ${isActive ? "bg-xmas-gold/15 font-semibold text-xmas-gold" : "text-xmas-slate hover:bg-white/5 hover:text-xmas-snow"}`;

function Brand() {
  return (
    <div className="px-5 pb-4 pt-6" data-testid="admin-brand">
      <p className="font-display text-lg tracking-wide text-xmas-snow">🎄 MY CHRISTMAS</p>
      <p className="mt-0.5 text-[11px] font-bold uppercase tracking-[0.25em] text-xmas-gold">Painel Administrativo</p>
    </div>
  );
}

function Nav({ onNavigate, onLogout }) {
  return (
    <div className="flex h-full flex-col">
      <Brand />
      <div className="mx-5 border-t border-xmas-gold/15" />
      <nav className="flex-1 space-y-1 px-3 py-4" data-testid="admin-nav">
        {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.end} onClick={onNavigate} className={linkCls} data-testid={`admin-nav-${n.to.split("/").pop()}`}><n.icon className="h-4 w-4" /> {n.label}</NavLink>)}
      </nav>
      <div className="mx-5 border-t border-xmas-gold/15" />
      <div className="space-y-1 px-3 py-4">
        <Link to="/app" onClick={onNavigate} className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-xmas-slate transition hover:bg-white/5 hover:text-xmas-snow" data-testid="admin-nav-platform"><Globe className="h-4 w-4" /> Ver plataforma</Link>
        <button onClick={onLogout} className="flex w-full items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-xmas-slate transition hover:bg-xmas-red/20 hover:text-xmas-snow" data-testid="admin-nav-logout"><LogOut className="h-4 w-4" /> Sair</button>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  if (user && user.role !== "admin") return <Navigate to="/app" replace />;
  const doLogout = async () => { await logout(); navigate("/"); };
  return (
    <div className="min-h-screen bg-xmas-navy text-xmas-snow" data-testid="admin-layout">
      <aside className="fixed left-0 top-0 z-40 hidden h-screen w-64 border-r border-xmas-gold/15 bg-xmas-navycard/90 lg:block" data-testid="admin-sidebar"><Nav onLogout={doLogout} /></aside>
      <header className="fixed inset-x-0 top-0 z-40 flex h-14 items-center justify-between border-b border-xmas-gold/15 bg-xmas-navycard/95 px-4 backdrop-blur-xl lg:hidden" data-testid="admin-mobile-header">
        <div><span className="font-display text-sm text-xmas-snow">🎄 MY CHRISTMAS</span> <span className="ml-2 text-[10px] font-bold uppercase tracking-[0.2em] text-xmas-gold">Admin</span></div>
        <button onClick={() => setOpen(true)} aria-label="Menu" data-testid="admin-menu-btn" className="rounded-lg p-2 text-xmas-snow hover:bg-white/5"><Menu className="h-5 w-5" /></button>
      </header>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden" data-testid="admin-drawer">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-0 h-full w-72 bg-xmas-navycard shadow-2xl">
            <button onClick={() => setOpen(false)} aria-label="Fechar" data-testid="admin-drawer-close" className="absolute right-3 top-4 rounded-lg p-2 text-xmas-slate hover:text-xmas-snow"><X className="h-5 w-5" /></button>
            <Nav onNavigate={() => setOpen(false)} onLogout={doLogout} />
          </div>
        </div>
      )}
      <main className="min-h-screen pt-16 lg:pl-64 lg:pt-0">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:py-8"><Outlet /></div>
      </main>
    </div>
  );
}
